import { render } from "./WarehouseDetails.vue?vue&type=template&id=036f5d61&scoped=true"
import script from "./WarehouseDetails.vue?vue&type=script&lang=js"
export * from "./WarehouseDetails.vue?vue&type=script&lang=js"

import "./WarehouseDetails.vue?vue&type=style&index=0&id=036f5d61&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036f5d61"]])

export default __exports__